"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _elMeasurements = require("../../../constants/elMeasurements");

var _utils = require("../../../../../../../utils");

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var EDGE_AUTO_SCROLL_DISTANCE = 20;

var DragHandler = /*#__PURE__*/function (_Component) {
  _inherits(DragHandler, _Component);

  var _super = _createSuper(DragHandler);

  function DragHandler() {
    var _this;

    _classCallCheck(this, DragHandler);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "onSelectTimestamp", function (e) {
      var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          isFinalEvent = _ref.isFinalEvent;

      e.preventDefault();
      e.stopPropagation();

      if (_this._autoScrollInterval && !isFinalEvent) {
        return;
      }

      var drawerContent = document.querySelector('.timeline .drawer__content');

      if (!drawerContent) {
        return;
      }

      var _this$props = _this.props,
          onSetTime = _this$props.onSetTime,
          timelineZoomSeconds = _this$props.timelineZoomSeconds;
      var dragTarget = _this.state.dragTarget;
      var xPos = e.clientX - _elMeasurements.TIMELINE_LEFT_OFFSET + drawerContent.scrollLeft;
      var clickedTime = xPos / _elMeasurements.TIMELINE_LABEL_WIDTH * timelineZoomSeconds;

      _this.handleAutoScroll(drawerContent, e.clientX, {
        isFinalEvent: isFinalEvent
      });

      onSetTime(clickedTime >= 0 ? clickedTime : 0, dragTarget);
    });

    _defineProperty(_assertThisInitialized(_this), "startDrag", function (e) {
      var player = document.querySelector('.video');

      if (!player) {
        return;
      }

      var playerX = player.offsetWidth;
      var cursor = _this.props.cursor;

      if (cursor) {
        _utils.globalCursor.set(cursor);
      }

      _this.setState({
        isDragging: true,
        playerX: playerX,
        dragTarget: e.target
      }, function () {
        document.addEventListener('mousemove', _this.onSelectTimestamp);
        document.addEventListener('mouseup', _this.stopDrag);
      });
    });

    _defineProperty(_assertThisInitialized(_this), "stopDrag", function (e) {
      _this.onSelectTimestamp(e, {
        isFinalEvent: true
      });

      var cursor = _this.props.cursor;

      if (cursor) {
        _utils.globalCursor.reset();
      }

      _this.setState({
        isDragging: false,
        dragTarget: void 0,
        playerX: 0
      }, function () {
        document.removeEventListener('mousemove', _this.onSelectTimestamp);
        document.removeEventListener('mouseup', _this.stopDrag);
      });
    });

    _this.state = {
      isDragging: false,
      playerX: 0,
      dragTarget: void 0
    };
    return _this;
  }

  _createClass(DragHandler, [{
    key: "handleAutoScroll",
    value: function handleAutoScroll(drawerContent, clientX, _ref2) {
      var _this2 = this;

      var isFinalEvent = _ref2.isFinalEvent;
      var playerX = this.state.playerX;
      var cursorInRightEdgeRange = clientX >= playerX - EDGE_AUTO_SCROLL_DISTANCE;
      var cursorInLeftEdgeRange = drawerContent.scrollLeft && clientX <= EDGE_AUTO_SCROLL_DISTANCE;
      var mouseInRangeOfEdge = cursorInRightEdgeRange || cursorInLeftEdgeRange;

      if (this._autoScrollInterval && (isFinalEvent || !mouseInRangeOfEdge)) {
        clearInterval(this._autoScrollInterval);
        this._autoScrollInterval = null;
      }

      if (mouseInRangeOfEdge && !this._autoScrollInterval && !isFinalEvent) {
        this._autoScrollInterval = setInterval(function () {
          var scrollAdjustment = cursorInLeftEdgeRange ? -1 : 1;
          drawerContent.scrollTo(drawerContent.scrollLeft + scrollAdjustment, 0);

          _this2.onSelectTimestamp({
            clientX: clientX,
            preventDefault: Function.prototype,
            stopPropagation: Function.prototype
          });
        }, 5);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          onSetTime = _this$props2.onSetTime,
          children = _this$props2.children;
      var isDragging = this.state.isDragging;
      return children({
        onMouseDown: onSetTime ? this.startDrag : void 0,
        isDragging: isDragging
      });
    }
  }]);

  return DragHandler;
}(_react.Component);

exports.default = DragHandler;